module.exports = __webpack_public_path__ + "static/media/font_bold.4e4f83ba.woff2";